import styled from "styled-components";
import data from "../../data.json";

export default function HeaderComponent() {
  return (
    <>
      <Header>
        <h1>{data.length} Things I've Learnt</h1>

        <p>
          This is a mini online library used to bookmark interesting reads about
          digital products and growing trends in our world.{" "}
          <a
            href="https://www.cassandratang.me"
            target="_blank"
            rel="noopener noreferrer"
          >
            Say hey.
          </a>
        </p>
      </Header>
    </>
  );
}

const Header = styled.header`
  display: block;
  padding: 20px 20px 40px 20px;

  @media (min-width: 820px) {
    padding: 40px 0px 40px 0px;
  }
`;
